var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVc = function SvgVc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M17.74 1.46A11.946 11.946 0 0 0 12 0C9.921 0 7.966.53 6.261 1.46L5.218 12 6.26 22.541c1.705.93 3.66 1.46 5.74 1.46 2.078 0 4.034-.53 5.739-1.46l1.043-10.54-1.044-10.542Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M6.26 22.54V1.46A11.997 11.997 0 0 0 0 12c0 4.549 2.53 8.506 6.26 10.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M24 12c0-4.548-2.53-8.505-6.26-10.54V22.54A11.997 11.997 0 0 0 24 12.001ZM9.392 15.13 7.305 12l2.087-3.131 2.087 3.13-2.087 3.13ZM14.61 15.13 12.522 12l2.086-3.131 2.087 3.13-2.087 3.13ZM12.001 19.304l-2.087-3.13 2.087-3.131 2.087 3.13-2.087 3.13Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgVc;